<template>
  <div class="recruitment_box">
    <div class="content_box">
      <div class="header">
        <div class="left_header">
          <el-select clearable style="margin-left: 25px;" v-model="getParams.degree" placeholder="请选择学历" @change="getList">
            <el-option v-for="item in education_option" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select clearable v-model="getParams.experience" placeholder="请选择工作经验" @change="getList">
            <el-option v-for="item in experienceOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select clearable v-model="getParams.status" placeholder="处理状态" @change="getList">
            <el-option v-for="(item,index) in status" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="right_header">
          <el-input v-model="getParams.keyword" class="input_box" @blur="getList" @keyup.enter="getList" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="table_box">
        <el-table :data="tableData" style="width: 100%" height="62vh" :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#f5f7fa',height:'60px'}" :cell-style="{fontSize: '14px',color: '#333',height:'80px'}">
          <el-table-column prop="resume_info.name" label="求职人">
            <template slot-scope="scope">
              {{ scope.row.resume_info.name }}
            </template>
          </el-table-column>
          <el-table-column prop="notice_time" label="通知时间">

          </el-table-column>
          <el-table-column prop="interview_time" label="面试时间">
          </el-table-column>
          <el-table-column prop="degree" label="面试职位">
            <template slot-scope="scope">
              {{ scope.row.position_info.name }}
            </template>
          </el-table-column>
          <el-table-column prop="interview_address" label="面试地点">
          </el-table-column>
          <el-table-column prop="interview_contact_name" label="联系人">
          </el-table-column>
          <el-table-column prop="interview_contact_phone" label="联系电话">
          </el-table-column>
          <el-table-column prop="status" label="处理状态">
            <template slot-scope="scope">
              {{ statusOption[scope.row.status+1] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button style="color: #685EF5;" type="text" @click="viewResume(scope.row)">查看简历</el-button>
              <el-button v-if="scope.row.status==0" style="color: #685EF5;" type="text" @click="ThroughPosition(scope.row.id,4)">通过</el-button>
              <el-button v-if="scope.row.status==0" style="color:#FF0000;" type="text" @click="ThroughPosition(scope.row.id,3)">未通过</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px;display: flex;justify-content: end;">
          <el-pagination @current-change="handleCurrentChange" :current-page="getParams.page" :page-size="getParams.page_size" layout="total, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <ViewResumeDialog ref="viewPositionRef" :position_info="position_info" :value="drawerVisible" @closeDrawer="closeDrawer" />
  </div>
</template>

<script>
import zymc from "../../../utils/zymc.json";
import ViewResumeDialog from "../../../components/companyModule/ViewResumeDialog.vue";
export default {
  name: "",
  components: { ViewResumeDialog },
  data() {
    return {
      getParams: {
        page: 1,
        page_size: 10,
        experience: "",
        degree: "",
        status: null,
        keyword: "",
      },
      poitionLabel: [],
      positionOption: [],
      education_option: [
        { label: "不限", value: "不限" },
        { label: "初中及以下", value: "初中及以下" },
        { label: "中专/中技", value: "中专/中技" },
        { label: "高中", value: "高中" },
        { label: "大专", value: "大专" },
        { label: "本科", value: "本科" },
        { label: "硕士", value: "硕士" },
        { label: "博士", value: "博士" },
      ],
      experienceOption: [
        {
          label: "1年以内",
          value: 1,
        },
        {
          label: "1-3年",
          value: 2,
        },
        {
          label: "3-5年",
          value: 3,
        },
        {
          label: "5-10年",
          value: 4,
        },
        {
          label: "10年以上",
          value: 5,
        },
      ],
      tableData: [],
      statusOption: [
        "已拒绝",
        "未处理",
        "",
        "",
        "未通过",
        "已通过",
        "",
        "未接受面试",
      ],
      status: [
        {
          label: "全部",
          value: -2,
        },
        {
          label: "已拒绝",
          value: -1,
        },
        {
          label: "未处理",
          value: 0,
        },
        {
          label: "未通过",
          value: 3,
        },
        {
          label: "已通过",
          value: 4,
        },
      ],
      zymc: zymc,
      position_info: {},
      drawerVisible: false,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleCurrentChange(val) {
      this.getParams.page = val;
      this.getList();
    },
    goPost() {
      this.$router.push("/company/post/position");
    },
    getList() {
      this.$httpcompany.axiosGetBy(
        this.$api.positionManageInterviewList,
        this.getParams,
        (res) => {
          if (res.code == 200) {
            this.tableData = res.data.list;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    viewResume(row) {
      // 查看简历
      Object.assign(this.position_info, row);
      this.drawerVisible = true;
    },
    ThroughPosition(id, status) {
      let params = {
        id: id, //投递ID/面试ID
        status: status, //状态: 3=未通过,4=已通过
      };
      this.$httpcompany.axiosPost(
        this.$api.positionManageChangeApplyStatus,
        params,
        (res) => {
          if (res.code == 200) {
            this.$message.success("修改成功");
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    editPosition(row) {
      this.$router.push({
        path: "/company/post/position",
        query: { id: row.id },
      });
    },
    viewPosition(row) {
      //   this.drawerVisible = true;
      //   Object.assign(this.position_info, row);
      //   this.$refs.viewPositionRef?.getDetial();
      //getDetial
    },
    deletePosition(row) {
      this.$confirm("是否删除该职位？删除后将无法恢复", "删除提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        customClass: "ek-confirm warning",
      }).then(() => {
        const params = { id: row.id };
        this.$httpcompany.axiosPost(
          this.$api.positionManageDeletePosition,
          params,
          (res) => {
            if (res.code === 200) {
              this.$message.success(res.message);
              this.getList();
            } else {
              this.$message.error(res.message);
            }
          }
        );
      });
    },
    // 打开弹框
    // 关闭弹框

    closeDrawer() {
      this.drawerVisible = false;
    },
  },
};
</script>
<style lang='scss' scoped>
.recruitment_box {
  width: 100%;
  height: calc(100vh - 100px);
  padding: 20px 20px 40px 20px;
  box-sizing: border-box;
  .content_box {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    .header {
      padding: 30px 40px 20px 40px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_header {
        display: flex;
        align-items: center;
        .el-select {
          width: 240px;
          height: 40px;
          margin-right: 24px;
        }
      }
      .right_header {
        display: flex;
        align-items: center;
        .input_box {
          width: 240px;
          height: 36px;
          margin-right: 24px;
        }
        .post_button {
          width: 88px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          background: #685ef5;
          color: #ffffff;
        }
      }
    }
    .table_box {
      padding: 30px 40px 20px 40px;
      width: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
